import React from 'react';
import './Bootcamps.css';
import { Navbar, ClassesHeader, BootcampCard } from '../../Components';
import { Helmet } from 'react-helmet';
import { DataContext } from '../../Context/Data';
import { Row, Col } from 'antd';

class Bootcamps extends React.Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  render() {
    return (
      <DataContext.Consumer>
        {
          data => (
            <div>
            <Helmet>
              <title>{data.profile.BusinessName ? data.profile.BusinessName : 'My Personal Training Website'}</title>
              <meta name="description" content={data.profile.BusinessStatement} />
              <link rel="icon" type="image/png" href={data.profile.LogoURL} />
            </Helmet>
            <Navbar />
            <ClassesHeader profile={data.profile} websiteTemplate={data.websiteTemplate} />
            <Row justify="space-around">
                <Col xs={23} sm={22}>
                    <Row gutter={[30,30]} align='stretch'>
                        {
                            data.bootcamps.map((boot) => {
                                return (
                                    <Col xs={24} sm={8}>
                                        <BootcampCard ColourScheme={data.profile.ColourScheme} bootcamp={boot} profile={data.profile} keyEvents={data.keyEvents} keyAvailability={data.keyAvailability} />
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </Col>
            </Row>
          </div>
          )
        }
      </DataContext.Consumer>
    )
  }
}

export default Bootcamps;